<template>
    <div class="all-bg">
        <div class="content-area">
            <div class="resources-content text-content">
                <img :src="activityImg" alt="活动图片">
            </div>
            <div>
                <div style="position: relative;">
                    <div class="text-content">合计符合领取条件用户：{{
                            activityOverallDetail.qualifiedMemberCount != null ? activityOverallDetail.qualifiedMemberCount : '？'
                        }} 人
                    </div>
                  <!-- 一次性活动不需要 -->
<!--                    <div class="text-content">数据截止至：{{-->
<!--                            activityOverallDetail.updateTime != null ? activityOverallDetail.updateTime : '？'-->
<!--                        }}-->
<!--                    </div>-->
                </div>
                <div class="dotted-border"></div>
                <div class="refresh-line-text-content">
                    已领取奖励用户（实时进度）：{{
                        activityOverallDetail.receivedMemberCount != null ? activityOverallDetail.receivedMemberCount : '？'
                    }} 人
                    <span class="mini-refresh-button" @click="requestActivityOverallDetail" :class="{ 'disabled': refreshDisable }">刷新</span>
                </div>
                <div class="text-content">
                    剩余可领取名额：{{ activityOverallDetail.remainingRewardCount != null ? activityOverallDetail.remainingRewardCount : '?' }} 个
                </div>
                <div class="text-content">总进度（实时进度）：</div>
                <div class="progress-container">
                    <!-- 进度条背景 -->
                    <div class="progress-bar">
                        <!-- 进度填充部分 -->
                        <div class="progress-fill"
                             :style="{ width: activityOverallDetail.activityProgress + '%' }"></div>
                        <!-- 进度文字（动态跟随） -->
                        <span class="progress-text" :style="{ left: `${activityOverallDetail.activityProgress > 85 ? 85 : activityOverallDetail.activityProgress}` + '%' }">{{
                                activityOverallDetail.activityProgress
                            }}%</span>
                    </div>
                </div>
            </div>
            <div class="progress-button" @click="checkMyProgress">
                <span style="color: white;font-size: 20px; line-height: 20px; font-weight: bold">查看本人进度</span>
            </div>
        </div>
    </div>
</template>

<script>

import {GetActivityOverallDetail} from "../../api/Activity";
import {BASE_URL} from "@/config/app";

export default {
    name: "Activity",
    data() {
        return {
            activityOverallDetail: {
                updateTime: null,
                qualifiedMemberCount: null,
                receivedMemberCount: null,
                remainingRewardCount: null,
                activityProgress: 0
            },
            refreshDisable: false,
            activityImg: BASE_URL + '/upload/images/activity_img.jpg'
        }
    },

    mounted() {
        this.requestActivityOverallDetail();
    },

    methods: {
        initActivityOverallDetail() {
          this.activityOverallDetail.qualifiedMemberCount = null;
          this.activityOverallDetail.receivedMemberCount = null;
          this.activityOverallDetail.remainingRewardCount = null;
          this.activityOverallDetail.activityProgress = 0;
        },
        requestActivityOverallDetail() {
            if (this.refreshDisable) {
                return;
            }
            this.refreshDisable = true;
            this.initActivityOverallDetail();
            GetActivityOverallDetail().then((response) => {
                if (response.code === this.$API_CODE.OK) {
                    this.activityOverallDetail = response.data;
                }
            }).finally(() => {
                this.refreshDisable = false;
            });
        },
        // 跳转本人进度页面
        checkMyProgress() {
            this.$router.push("/mine")
        }
    }
}
</script>

<style lang="scss" scoped>
/* pages/activity.wxss */
.all-bg {
    width: 100%;
    height: 100%;
    background: white;
    display: flex; /* 启用 Flex 布局 */
    justify-content: center; /* 水平居中 */
}

.content-area {
    width: 90%;
}

.refresh-line-text-content {
    position: relative;
    color: #ea2d53; /* 红色文字 */
    font-weight: bold;
    font-size: 15rpx;
    margin-top: 0.2rem;
    text-align: left;
}

.text-content {
    color: #ea2d53; /* 红色文字 */
    font-weight: bold;
    font-size: 15rpx;
    margin-top: 0.2rem;
    text-align: left;
}

.dotted-border {
    margin:10px 0;
    border-top: 1px dashed #ea2d53;
}

.mini-refresh-button {
    position: absolute;
    right: 0;
    text-align: center;
    font-size: 14px;
    padding: 2px;
    border-radius: 15px;
    width: 50px;
    color: white;
    background: #ea2d53;

    &.disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

.refresh-button.disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.progress-button {
    text-align: center;
    padding: 8px 8px;
    background: #ea2d53;
    margin-top: 1rem;
    border-radius: 25px;
    color: #ea2d53;
}

/* 进度条容器 */
.progress-container {
    padding-top: 5px;
}

/* 进度条整体样式（灰黑色边框） */
.progress-bar {
    width: 100%;
    height: 25px;
    background: #f5f5f5;
    box-sizing: border-box;
    border: 0.1px solid #9f9f9f; /* 灰黑色边框 */
    border-radius: 25px;
    position: relative;
    overflow: hidden;
}

/* 进度填充部分 */
.progress-fill {
    height: 100%;
    background: #ea2d53;
    border-radius: 25px;
    transition: width 0.3s ease-in-out;
}

/* 进度文字样式（红色、右侧跟随） */
.progress-text {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: #000000; /* 红色文字 */
    font-weight: bold;
    font-size: 15px;
    margin-left: 5px; /* 文字与进度条的间距 */
    z-index: 2;
    white-space: nowrap; /* 防止文字换行 */
}

/* 防止文字超出右侧边界（100%时微调） */
.progress-text[style*="100%"] {
    left: auto !important;
    right: 0;
}

.resources-content {
    /* 新增盒子样式 */
    width: 350px;
    height: auto;
    border: 1px solid #ea2d53;
    border-radius: 8px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center; /* 垂直居中 */
    margin: 20px auto; /* 上下留白20px，水平居中 */
    overflow: hidden; /* 防止图片溢出盒子 */
}

.resources-content img {
    width: 100%;
    height: auto;
}
</style>

